const config = {
  // Landing Page
  landingcontent: {
    title: "Discover The Brielle Senior Living, Staten Island, New York",
    subtitle:
      "Senior living that feels steady, supportive, and comfortable",
    description:
      "At The Brielle, we provide New York, NY seniors and families with senior living that feels calm, connected, and well supported. Our care-inclusive non-profit Assisted Living and Memory Care community is situated on a beautifully wooded 10-acre campus adjacent to the Greenbelt in Staten Island.",
    keywords:
      "The Brielle, senior living Staten Island, senior living New York, assisted living Staten Island, memory care Staten Island, senior housing New York, elder care, senior residence, 140 Friendship Ln, Staten Island NY 10314.",
  },

  // Checkout Page
  checkoutcontent: {
    title: "Schedule a Visit to The Brielle",
    description:
      "The Brielle is a senior living option for families in and around New York, NY, who want a calm, supportive place for a loved one. Call +1 929-256-3005 or 929-810-4863 to learn more about assisted living, memory care, and senior housing at 140 Friendship Ln, Staten Island, NY 10314.",
    keywords:
      "Schedule a visit, The Brielle, assisted living, memory care, senior housing, senior community, elder care, Staten Island NY, New York senior living, senior residence.",
  },

  // About Us Page
  aboutcontent: {
    title: "The Brielle Senior Living in Staten Island, NY",
    subtitle:
      "A calm, supportive senior community with assisted living and memory care",
    description:
      "As a senior community, The Brielle focuses on everyday support that feels respectful and personal, with options that fit different needs, from assisted living to memory care. Residents, visitors, and family members enjoy outdoor patios, walking paths, wildlife, and natural surroundings while staying close to shopping, dining, and local points of interest.",
    keywords:
      "The Brielle, senior living Staten Island NY, assisted living community, memory care community, senior housing, elder care facility, senior residence, supportive care, comfort, routine, safety, Greenbelt Staten Island.",
    header: "The Brielle - Comfort, Care, and Community",
    message:
      "At The Brielle, our team supports residents day to day so they can enjoy a calm routine in a caring senior community.",
  },
  aboutbusiness: {
    paragraph1:
      "At The Brielle, our assisted living community blends comfort, care, and hospitality in a beautiful, thoughtfully designed space that supports seniors every day.",
    paragraph2:
      "We are an assisted living community that provides help with everyday tasks, and we also offer memory care for residents who need extra support with safety and routines. If you are searching for a senior residence that feels calm, respectful, and easy to settle into, The Brielle is here to talk through your needs and next steps.",
  },
  littleaboutus: {
    paragraph1:
      "Quiet comfort matters when you are choosing a place to live, and The Brielle is built for that kind of everyday ease in New York. Our senior living option focuses on a calm, home-like feel, with support nearby when you need it.",
    paragraph2:
      "A good day starts with a space that feels peaceful and familiar. At The Brielle in New York, we focus on senior living that supports comfort, privacy, and daily routines.",
    paragraph3:
      "Our senior housing includes support for daily needs in an assisted living facility, plus additional help through memory care when needed. Schedule a visit and see if our community is the right fit for you or your loved one.",
  },

  // Contact Page
  contactcontent: {
    title: "Contact The Brielle in Staten Island, NY",
    description:
      "At The Brielle, we offer senior living that feels calm and well supported, with easy access for families visiting from New York, NY. Contact us at +1 929-256-3005 or visit us at 140 Friendship Ln, Staten Island, NY 10314.",
    keywords:
      "Contact The Brielle, The Brielle phone, The Brielle address, 140 Friendship Ln, Staten Island NY 10314, assisted living contact, memory care contact, senior living Staten Island.",
    message:
      "Whether you are comparing a nursing home or exploring assisted living, we are here to help you understand what makes sense for your family.",
  },

  // Photo Gallery Page
  gallerycontent: {
    title: "The Brielle Senior Living Photo Gallery",
    description:
      "Thoughtfully designed senior living spaces at The Brielle support comfort, safety, and everyday ease. Explore inviting common areas, dining spaces, peaceful rooms, outdoor paths, and memory care spaces that feel familiar and welcoming.",
    keywords:
      "The Brielle photos, senior living gallery, assisted living spaces, memory care suites, senior housing photos, senior residence Staten Island, comfortable senior living, peaceful senior community.",
    message:
      "Comfortable, welcoming spaces help make The Brielle feel like home within our trusted senior living community.",
  },

  // Menu Page
  ordercontent: {
    title: "Assisted Living and Memory Care at The Brielle",
    description:
      "The Brielle offers senior living that feels calm, safe, and easy to settle into. Families from New York, NY often want a place that supports both independence and daily help, and our senior community is built for that balance.",
    keywords:
      "The Brielle assisted living, The Brielle memory care, senior living New York, senior housing Staten Island, elder care facility, nursing home alternative, supportive senior community, memory care apartments.",
    message:
      "Comfort, care, and peaceful surroundings come together at our assisted living facility. Schedule your visit today.",
  },

  // Eloyalty Page
  eloyaltycontent: {
    title: "The Brielle Senior Living Community",
    description:
      "A welcoming senior community providing peaceful gathering spaces and compassionate, person-centered support. The Brielle supports comfort, routine, safety, and connection for seniors and families in New York.",
    keywords:
      "The Brielle, senior living community, senior residence, assisted living facility, memory care community, senior housing, elder care, compassionate support, Staten Island New York.",
    message:
      "Warm, engaging senior living communities foster joy - discover our memory care community today.",
  },

  // SignInSL Page
  signinslcontent: {
    title: "The Brielle Resident Portal",
    description:
      "Sign in to access The Brielle resident portal. The Brielle is a Staten Island senior living community offering assisted living and memory care in a calm, supportive setting.",
    keywords:
      "The Brielle resident portal, The Brielle sign in, senior living portal, assisted living portal, memory care portal, Staten Island senior living.",
  },
};

export default config;
